module.exports = __webpack_public_path__ + "media/packs/landing_page/images/activities/hiit-06248d95efcd6f9c17e2d432783d10bf.png";